import { createSelector } from '@ngrx/store';

import { paymentState } from '../root';

export const getPaymentState = createSelector(paymentState, (payment) => payment);
